import { chakra, Text } from '@chakra-ui/react';

export const HeadingText = chakra(Text, {
  baseStyle: () => ({
    fontWeight: 'bold',
    fontSize: 'sm',
    mb: '2',
  }),
});
